$(function() {

    $.nursing = {};

    $.nursing.delayFadeOut = ($("#nursing-container").next('section').hasClass('profile-section')) ? false : true;

    $.nursing.lastProfile = false;

    // durations

    $.nursing.duration = '75%';

    $.nursing.calculatePinDuration = function() {
        var contentHeight = $('#nursing-container .content-container').outerHeight();
        if ($.nursing.lastProfile) {
            $.nursing.pinDuration = 0;
        } else {
            $.nursing.pinDuration = Math.round(contentHeight + $(window).innerHeight());
        }
        return $.nursing.pinDuration;
	};

    $.nursing.zoomDuration = '100%';

    $.nursing.endDuration = ($.nursing.delayFadeOut) ? '150%' : '50%';

    // timelines

    $.nursing.tl = {};

    // in

	$.nursing.tl.in = new TimelineMax();

    $.nursing.tl.in.addLabel("start");

    $.nursing.tl.in.set("#nursing-container", { visibility: "visible" }, "start");﻿

    if (!$.ms) {

        $.nursing.tl.in.from("#nursing-svg .line-1", 1, { x:"2560" }, "start");
        $.nursing.tl.in.from("#nursing-svg .line-2", 1, { x:"2560", delay: 0.25 }, "start");
        $.nursing.tl.in.from("#nursing-svg .line-3", 1, { x:"2560", delay: 0.5 }, "start");
        $.nursing.tl.in.add(function(){ /* pause */ }, "+=0.25");

        new ScrollMagic.Scene({ triggerElement: '#nursing-in', triggerHook: 'onEnter', duration: $.nursing.duration })
        	.setTween($.nursing.tl.in)
        	// .addIndicators({name: 'nursing in'})
        	.addTo($.controller);

    }

    // pin

    new ScrollMagic.Scene({ triggerElement: '#nursing-pin', triggerHook: 'onLeave', duration: $.nursing.calculatePinDuration })
        .setPin('#nursing-container .svg-background')
        // .addIndicators({name: 'nursing pin'})
        .addTo($.controller);

    // zoom

    $.nursing.zoom = {};

    $.nursing.tl.zoom = new TimelineMax();

    $.nursing.tl.zoom.addLabel("start");
    $.nursing.tl.zoom.addLabel("content", 2);

    if ($.ms || ($.windowWidth > $.breakpoint.e3 && $.safari)) { // zoom

        $.nursing.tl.zoom.to("#nursing-svg .svg-text", 2, { y:"-320" }, "start");

    } else {

        $.nursing.zoom.scale = 10;
        $.nursing.zoom.offset = $.nursing.zoom.scale * 100 / 2;
        $.nursing.zoom.xy = "-"+ $.nursing.zoom.offset +"%";

        $.nursing.tl.zoom.to("#nursing-svg .svg-text", 2, { x:$.nursing.zoom.xy, y:$.nursing.zoom.xy, scaleX:$.nursing.zoom.scale, scaleY:$.nursing.zoom.scale, force3D:true }, "start");

    }

    $.nursing.tl.zoom.to("#nursing-container .svg-img-overlay-mask", 0.5, { opacity:0 }, "start");
    $.nursing.tl.zoom.to("#nursing-background", 0.5, { backgroundColor:$.color.black, delay:1 }, "start");
    $.nursing.tl.zoom.fromTo("#nursing-svg .svg-img .img-default", 0.5, { opacity:0 }, { opacity:1, delay:1.5 }, "start");
    $.nursing.tl.zoom.set("#nursing-svg .svg-bg", { visibility:"hidden", delay:2 }, "start");﻿
    $.nursing.tl.zoom.set("#nursing-svg .svg-img-mask", { visibility:"hidden", delay:2 }, "start");﻿

    $.nursing.tl.zoom.fromTo("#nursing-container .svg-img-overlay", 0.5, { opacity:0 }, { opacity:1 }, "content");
    $.nursing.tl.zoom.fromTo("#nursing-container .svg-content-overlay", 0.5, { opacity:0 }, { opacity:1 }, "content");
    if ($.windowWidth > $.breakpoint.lg) {
        $.nursing.tl.zoom.fromTo("#nursing-container .svg-content-overlay", 0.5, { x:"-100%" }, { x:"0%" }, "content");
    }
    $.nursing.tl.zoom.fromTo("#nursing-container .content-container", 0.5, { opacity:0 }, { opacity:1, delay:0.5 }, "content");

    new ScrollMagic.Scene({ triggerElement: '#nursing-zoom', triggerHook: 'onCenter', duration: $.nursing.zoomDuration })
        .on('start', function () {
            $.nursing.tl.in.seek($.nursing.tl.in.duration(), false);
        })
        .setTween($.nursing.tl.zoom)
        // .addIndicators({name: 'nursing zoom'})
        .addTo($.controller);

    $.nursing.tl.out = new TimelineMax();

    $.nursing.tl.out.addLabel("start");

    $.nursing.tl.out.to("#nursing-container .content-container", 1, { opacity:0 }, "start");

    if ($.nursing.delayFadeOut) {
        $.nursing.tl.out.to("#nursing-background", 1, { opacity:0, delay:2 }, "start");
    } else {
        $.nursing.tl.out.to("#nursing-background", 1, { opacity:0 }, "start");
    }

    new ScrollMagic.Scene({ triggerElement: '#nursing-end', triggerHook: 'onCenter', duration: $.nursing.endDuration })
        .setTween($.nursing.tl.out)
        // .addIndicators({name: 'nursing out'})
        .addTo($.controller);

});
